// extracted by mini-css-extract-plugin
export var background = "rich-text-module--background--702f8";
export var content = "rich-text-module--content--b6843";
export var hero = "rich-text-module--hero--d0e0c";